import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const Container: StyleRule = () => ({
    overflow: 'hidden',
    width: '100%',
    marginTop: pxToRem(5),
});

export const Wrapper: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([11, 35, 11, 22]),
    width: '100%',
    background: theme.siteVariables.colors.primitive.white,
});

export const InnerContainer: StyleRule = () => ({
    width: '100%',
});

export const CloseButton: StyleRule = () => ({
    cursor: 'pointer',
    margin: pxArrayToRem([10, 14]),
    position: 'absolute',
    top: 0,
    right: 0,
    width: pxToRem(16),
});

export const ColourDetails: StyleRule = () => ({
    flexGrow: 1,
});

export const ColourName: StyleRule = ({ theme }) => ({
    margin: 0,
    ...theme.siteVariables.textStyles.Text.Medium65,
    fontSize: pxToRem(22.62),
    lineHeight: 1.25,
    color: theme.siteVariables.colors.charcoal['250'],
});

export const ColourCode: StyleRule = ({ theme }) => ({
    margin: 0,
    ...theme.siteVariables.textStyles.Text.Roman55,
    fontSize: pxToRem(19.39),
    lineHeight: 1.25,
    color: theme.siteVariables.colors.grey['300'],
});

export const ProductLink: StyleRule = ({ theme }) => ({
    margin: 0,
    textDecoration: 'none',
    ...theme.siteVariables.textStyles.Text.Roman55,
    fontSize: pxToRem(22.62),
    lineHeight: 1.25,
    color: theme.siteVariables.colors.charcoal['250'],
    '&:hover': {
        color: theme.siteVariables.colors.primitive.black,
    },
});
